<template>
  <div class="Slider" :class="additionalClass">
    <div class="Slider__wrapper">
      <div class="Slider__track">
        <Slide
          v-for="({ href, logo }, index) in slides"
          :key="`${href}_${index}`"
          :slide="{ href, logo }"
        />
      </div>
      <div class="Slider__more">
        <router-link
          :to="route"
          class="Slider__button-more button button_primary"
        >
          <span>{{ $t("VUE.MORE_DETAILS") }}</span>
        </router-link>
      </div>
    </div>

    <button class="Slider__button Slider__button_prev">
      <svg
        width="17"
        height="20"
        viewBox="0 0 17 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.82796 2L2 10L9.82796 18M15 2.4L7.45161 10L15 17.2"
          stroke="#2979FF"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
    <button class="Slider__button Slider__button_next">
      <svg
        width="17"
        height="20"
        viewBox="0 0 17 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.17204 18L15 10L7.17204 2M2 17.6L9.54839 10L2 2.8"
          stroke="#2979FF"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </div>
</template>

<script>
import Slide from "@/components/app/Slide";
import Slider from "@/plugins/slider.plugin";

export default {
  name: "Slider",
  props: {
    slides: {
      type: Array,
      required: true
    },
    additionalClass: {
      type: String,
      required: true
    },
    route: {
      type: String
    }
  },
  data: () => ({
    slider: null
  }),
  mounted() {
    this.slider = new Slider(`.${this.additionalClass}`, {
      buttons: {
        prev: ".Slider__button_prev",
        next: ".Slider__button_next"
      },
      slides: {
        slidesToShow: 2,
        slidesToScroll: 1
      },
      slide: ".Slider__slide",
      track: ".Slider__track"
    });
  },
  beforeDestroy() {
    this.slider && this.slider.destroy ? this.slider.destroy() : null;
  },
  components: {
    Slide
  }
};
</script>

<style lang="scss">
@import "@/assets/_vars";

/*<slider>*/
.Slider {
  position: relative;

  &__wrapper {
    position: relative;
    overflow: hidden;
  }

  &__track {
    display: flex;
    padding: 10px 0;
    margin: 0 auto;
    transition: 0.4s;
  }

  &__slide {
    padding: 0 10px;

    &_wrap {
      display: flex;
      justify-content: center;
      min-height: 100%;
      background-color: $sec_bg;
    }
  }

  &__link {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 100%;
    padding: 10px 25px;
    border-radius: 15px;
    transition: box-shadow 0.2s;

    img {
      max-width: 120px;
      max-height: 70px;
    }
  }

  &__button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    cursor: pointer;
    border-radius: 10em;
    box-shadow: 0 3px 5px rgba(#000, 0.2);
    -webkit-tap-highlight-color: transparent;

    &_prev,
    &_next {
      position: absolute;
      top: 35%;
      background-color: $sec_bg;
      transform: translateY(-50%);
    }

    &_prev {
      left: -20px;
    }

    &_next {
      right: -20px;
    }

    &:disabled {
      svg {
        path {
          stroke: rgba(#2979ff, 0.4);
        }
      }
    }

    &:focus {
      outline: none;
      box-shadow: 0 0 1px 3px rgba(#2979ff, 0.75);
    }
  }

  &__more {
    display: flex;
    justify-content: center;
    margin: 5px 0;
  }

  &__button-more {
    padding: 7.5px 15px;
  }
}
</style>
